import React, { useEffect, useState, useContext } from 'react';
import { Container, Typography, Box,Card, CardContent, Button, Stack, Alert } from '@mui/material';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@mui/material';
import scadenzaApi from '../../api/scadenzaApi';
import { useParams, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../../components/ConfirmDeleteModal';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { AuthContext } from '../../auth/AuthContext';
import { formatDate } from '../../utils/dateFormatter';
import QRCode from 'react-qr-code';
import { QrCode2 } from '@mui/icons-material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default function ScadenzaDetailPage() {
  const { id } = useParams();
  const { user } = useContext(AuthContext);
  const [scadenza, setScadenza] = useState(null);
  const [err, setErr] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    scadenzaApi.get(id)
      .then(r => setScadenza(r.data))
      .catch(e => setErr(e.response?.data || e.message));
  }, [id]);

  if (err) return <Alert severity="error">{String(err)}</Alert>;
  if (!scadenza) return <div>Loading...</div>;

  const handleEdit = () => {
    navigate(`/scadenze/edit/${id}`);
  };

  // Mostra modale
  const confirmDelete = () => {
    setOpenDelete(true);
  };

  // Elimina scadenza dopo conferma
  const handleDelete = async () => {
    try {
      await scadenzaApi.delete(id);
      navigate(-1); // torna alla pagina precedente
    } catch (e) {
      setErr(e.response?.data || e.message);
    } finally {
      setOpenDelete(false);
    }
  };

  return (
    <Container>
    <BackButtonDesktop />
      <Typography variant="h4">Dettaglio Scadenza</Typography>

      <Card sx={{ mt: 2 }}>
        <CardContent>
          <Typography sx={{ visibility: 'hidden' }} ><strong>Id:</strong> {scadenza.id}</Typography>
          <Typography><strong>Tipo:</strong> {scadenza.tipo}</Typography>
          <Typography><strong>Data Scadenza:</strong> {formatDate(scadenza.dataScadenza)}</Typography>
          <Typography><strong>Importo:</strong> {scadenza.importo}</Typography>
          <Typography><strong>Codice mod. Pagamento:</strong> {scadenza.codiceModuloPagamento}</Typography>
          <Typography sx={{ visibility: 'hidden' }} ><strong>Documento Id:</strong> {scadenza.documentoId}</Typography>
          <Typography sx={{ visibility: 'hidden' }} ><strong>Contribuente Id:</strong> {scadenza.contribuenteId}</Typography>
            {scadenza.qrcode && scadenza.qrcode!=="" && (
              <Box textAlign="center" mt={3}>
                <Typography variant="h6">Leggi il qrcode CBILL/PagoPa con l'app della tua banca</Typography>
                <QRCode value={scadenza.qrcode} />
                <Typography mt={1}>
                  {scadenza.qrcode}
                </Typography>
              </Box>
            )}
          <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <ProtectedAction user={user} contractState={user.statoContratto}>
            <Button variant="contained" onClick={handleEdit}>Modifica</Button>
            <Button variant="outlined" color="error" onClick={confirmDelete}>Elimina</Button>
          </ProtectedAction>
          </Stack>
        </CardContent>
      </Card>
        {scadenza.tributi && scadenza.tributi.length > 0 && (
          <>
            <Typography variant="h6" sx={{ mt: 3 }}>
              Tributi
            </Typography>

            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Codice</TableCell>
                  <TableCell>Anno</TableCell>
                  <TableCell align="right">Debito</TableCell>
                  <TableCell align="right">Credito</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {scadenza.tributi.map((t) => (
                  <TableRow key={t.id}>
                    <TableCell>{t.codiceTributo}</TableCell>
                    <TableCell>{t.annoRiferimento}</TableCell>
                    <TableCell align="right">{t.importoDebito}</TableCell>
                    <TableCell align="right">{t.importoCredito}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        )}
      {/* Modale conferma eliminazione */}
      <ConfirmDialog
        open={openDelete}
        onCancel={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        title="Conferma Eliminazione"
        message="Sei sicuro di voler eliminare questa scadenza?"
      />
    </Container>
  );
}